import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive } from '@angular/router';

import {environment} from '../../../environments/environment';

import {SessionService} from '../../services/session.service';

declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
  tooltip: string;
  group?: string;
  module?: string;
  role: number[];
  scope?: number;
}

declare const $: any;


@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, AfterViewInit {

  // region Atributos
  menuItems: any[];
  menuResults: any[];
  public role: string = null;
  public allowed: boolean;
  // rolesNum = RoleEnum;
  //public userData: Profile;
  public status: string;
  public errors: string;
  public message_success: string;
  public appName = environment.app_name;
  public ROUTES;

  public spinner = false;
  // endregion

  // region Constructor
  constructor(
    public userService: SessionService,
    public activateRoute: ActivatedRoute,
    public router: Router
    // private messageService: MessageService,
  ) {
  }
  // endregion

  // region Métodos

  ngAfterViewInit(): void {

      // Rutas que se mostrarán en el sidebar menu
      this.ROUTES = [
        { path: '/users/list', group: null, module: 'users', title: 'Listado Usuarios', tooltip: 'Listado Usuarios', icon: 'list', class: '', role: [null], scope: null},
        { path: '/groups/list', group: null, module: 'groups', title: 'Listado Grupos', tooltip: 'Listado Grupos', icon: 'list', class: '', role: [null], scope: null},
        { path: '/posts', group: null, module: 'posts', title: 'Post. Comidas', tooltip: 'Listado de Publicaciones', icon: 'restaurant_menu', class: '', role: [null], scope: null},
        { path: '/posts/body/list', group: null, module: 'posts', title: 'Post. Img Semanales', tooltip: 'Listado de Imagenes Corporales', icon: 'accessibility', class: '', role: [null], scope: null},
        { path: '/posts/with-or-out-posts', group: null, module: 'posts', title: 'Con o Sin Publicaciones', tooltip: 'Listado de Usuarios por tipo de publicación', icon: 'person_search', class: '', role: [null], scope: null},
        { path: '/posts/total-foods-users', group: null, module: 'posts', title: 'Total Comidas x Usuario', tooltip: 'Total Comidas x Usuario', icon: 'local_dining', class: '', role: [null], scope: null},
        { path: '/posts/average-qualify-users', group: null, module: 'posts', title: 'Promedio | Puntajes x Usuario', tooltip: 'Promedio | Puntajes x Usuario', icon: 'local_dining', class: '', role: [null], scope: null},
        // { path: '/payments/in-transit', group: 'Reports', module: 'reports', title: 'Payments in transit', tooltip: 'Payments in transit', icon: 'edit', class: '', role: [null], scope: 1},
        // { path: '/payments/processed', group: 'Reports', module: 'reports', title: 'Processed payments', tooltip: 'Processed payments', icon: 'monetization_on', class: '', role: [null], scope: 1},
  {
  path: '/reports/group-photo-report',
  module: 'reports',
  title: 'Reporte Fotos por Grupo',
  icon: 'assessment'
}

      ];
      this.menuItems = this.ROUTES.filter(menuItem => menuItem);

      const groups = new Set(this.menuItems.map(item => item.group));

      this.menuResults = [];
      groups.forEach(g =>
        this.menuResults.push({
            name: g,
            values: this.menuItems.filter(i => i.group === g),
            module: ''
          }
        ));

      for (let i = 0; i < this.menuResults.length; i++) {
        for (let j = 0; j < this.menuResults[i].values.length; j++) {
          if(j == 0) {
            this.menuResults[i].module = this.menuResults[i].values[j].module;
          }
        }
      }


    console.log();

  }

  ngOnInit() {
    //obtenemos valores del perfil del usuario
    //this.userData = this.userService.getProfile();
  }

  // Función para verificar si cumple con la directiva de roles de usuario
  isAllowed(roles) {
    let allowed = false;
    for (let i = 0; i < roles.length; i++) {
      if (roles[i] == this.role) {
        return allowed = true;
      }
    }
  }

  isIntern(scope) {
    // if (!this.userService.getProfile().intern) {
    //   return false;
    // }
    // let intern = Number(this.userService.getProfile().intern);

    // if (intern == scope) {
    //   return true
    // }
    // return false;
  }

  // Función para verificar si el display del dispositivo es mayor a 991px
  isMobileMenu() {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  }

  expandActiveLink(param) {
    return this.router.isActive(param, false);
  }
  // endregion
}



